export default __webpack_public_path__ + "images/tw-83324ef79fd96b77a6090612fad174df.svg";